module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/redux-act-async/~/babel-runtime/core-js/object/define-property.js
// module id = 2102
// module chunks = 0